<template>
  <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName" />
  </svg>
</template>
 
<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    suffix: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    iconName() {
      if(this.suffix){
        let fileClass = "default-file";
          //TODO 截取后缀
        // ppt,pdf,word,txt,excel,default
        let strSuff = this.iconClass.substring(this.iconClass.lastIndexOf(".")+1).toLowerCase();
        console.log(this.suffix,strSuff)
        switch(strSuff){
          case "pdf":
            fileClass = "pdf";
            break;
          case "ppt":
            fileClass = "ppt";
            break;
          case "pptx":
            fileClass = "pptx";
            break;
          case "doc":
            fileClass = "doc";
            break;
          case "docx":
            fileClass = "docx";
            break;
          case "txt":
            fileClass = "txt";
            break;
          case "xlsx":
            fileClass = "xlsx";
            break;
          case "xls":
            fileClass = "xls";
            break;
        }
        return  `#icon-${fileClass}`;
      }
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon-" + this.className;
      } else {
        return "svg-icon";
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        "-webkit-mask": `url(${this.iconClass}) no-repeat 50% 50%`,
      };
    },
  },
};
</script>
 
<style scoped>
.svg-icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}

.svg-icon-menu {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.13em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon-file {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.2em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon-content {
  width: 1.0em;
  height: 1.0em;
  vertical-align: -0.10em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon-title {
  width: 2.0em;
  height: 2.0em;
  vertical-align: -0.50em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon-logo {
  width: 200px;
  height: 50px;
  vertical-align: -0.50em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue